import SectionTabs from './section-tabs'

export default SectionTabs;
